// extracted by mini-css-extract-plugin
export var modalFooter = "_sv-0";